import React, { useMemo } from "react";
import { Field } from "react-final-form";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import BootstrapInput from "../../../../../components/BootstrapInput";
import Autocomplete from "../../../../../components/Autocomplete";
import { currencies } from "../../../../../utils/const/currencies";
import { ShowCurrency } from "./ShowCurrency";
import { COMMISSION_TYPES, getDurationUnits } from "../../../../../constants";

const durationUnitWithoutDays = getDurationUnits("Program").slice(1);

const useStyles = makeStyles(() => ({
  tuition: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#535358",
    lineHeight: 1,
    marginBottom: 16,
  },
}));

const Tuition = ({ name, durationAmountRequired = true }) => {
  const classes = useStyles();

  const currencyList = useMemo(
    () =>
      currencies.map((item) => ({
        id: item.id,
        name: item.code,
      })),
    [],
  );

  return (
    <div>
      <Typography className={classes.tuition}>Tuition</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={6}>
          <Field
            required
            fullWidth
            type="text"
            label="Tuition fee"
            placeholder="Only numbers"
            infoIcon={"Tuition of 1st year"}
            name={`${name}.tuition`}
            component={BootstrapInput}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Field
            required
            fullWidth
            label="Currency"
            options={currencyList}
            placeholder="Please Select"
            infoIcon={"Choose currency you require"}
            name={`${name}.currency`}
            component={Autocomplete}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Field
            required
            fullWidth
            label="Duration Period"
            options={durationUnitWithoutDays}
            placeholder="Please Select"
            name={`${name}.tuitionDurationUnit`}
            component={Autocomplete}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Field
            required={durationAmountRequired}
            fullWidth
            type="text"
            disabled={!durationAmountRequired}
            label="Duration"
            placeholder={durationAmountRequired ? "Only numbers" : ""}
            infoIcon={"The price you indicate for the following period"}
            name={`${name}.tuitionDurationAmount`}
            component={BootstrapInput}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <Field
            required
            fullWidth
            type="text"
            label="Commission"
            placeholder="Only numbers"
            infoIcon={"Indicate percentage or fee for 1st year"}
            name={`${name}.commissionAmount`}
            component={BootstrapInput}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <Field
            required
            fullWidth
            label="Type"
            options={COMMISSION_TYPES}
            placeholder="Please Select"
            name={`${name}.commissionType`}
            component={Autocomplete}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <ShowCurrency />
        </Grid>
      </Grid>
    </div>
  );
};

export default Tuition;
